import { render } from "./TopWidgets.vue?vue&type=template&id=5c988ea4&scoped=true"
import script from "./TopWidgets.vue?vue&type=script&lang=js"
export * from "./TopWidgets.vue?vue&type=script&lang=js"

import "./TopWidgets.vue?vue&type=style&index=0&id=5c988ea4&scoped=true&lang=css"

import exportComponent from "/tmp/build_f9a89c39/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c988ea4"]])

export default __exports__